import { Box, Button, CircularProgress, createTheme, MuiThemeProvider, useMediaQuery } from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import moment from "moment";
import MUIDataTable from "mui-datatables";
import { Link } from "react-router-dom";
import { useEffect, useState , useMemo } from "react";
import { handleChangeRowsPerPage, getRowsPerPage } from "./../../../utils/DataTables";
import { handleOnViewColumnsChange } from "./../../../utils/viewColumns";
import { getRowData } from "../../../utils/FunctionHelpers";
import ProductionDetailModal from "../../Pilotage/Components/ProductionDetailModal";
import { getPilotageClientsDetail } from "../../Services/PilotageService";

const missionListStyle = createTheme({
    overrides: {
        MUIDataTableToolbar: {
            root: {
                display: 'none'
            }
        }
    }
});

const MissionsTable = ({ ...props }) => {
    const columns = [
        {
            name: "uuid",
            label: "N°",
            options: {
                display: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    const row = getRowData(tableMeta, columns);
                    return (
                        <>
                            <Box data-toggle="tooltip" title={value} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", width: "100px" }}>
                                <Link to={{ pathname: `/societe/${row.societeId}/missions/${row.uuid}/view` }} className="d-print-none font-sm" style={{ textDecoration: "none" }}>{value}</Link>
                            </Box>
                        </>
                    );
                },
            },
        },
        {
            name: "numMission",
            label: "N°",
            options: {
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    const row = getRowData(tableMeta, columns);
                    return (
                        <>
                            <Box data-toggle="tooltip" title={value} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", width: "3rem" }}>
                                <Link to={{ pathname: `/societe/${row.societeId}/missions/${row.uuid}/view` }} className="d-print-none font-sm" style={{ textDecoration: "none" }}>{value}</Link>
                            </Box>
                        </>
                    );
                },
            },
        },
        {
            name: "client",
            label: "CLIENT",
            options: {
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    const row = getRowData(tableMeta, columns);
                    return (
                        <>
                            <Box data-toggle="tooltip" title={value} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", width: "100px" }}>
                                <Link to={{ pathname: `/societe/${row.societeId}/view` }} className="d-print-none font-sm" style={{ textDecoration: "none" }}>{value ? value : ""}</Link>
                            </Box>
                        </>
                    );
                },
            },
        },
        {
            name: "nom_mission",
            label: "NOM MISSION",
            options: {
                sort: true,
                setCellHeaderProps: () => ({ style: { whiteSpace: "nowrap" } }),
                customBodyRender: (value, tableMeta, updateValue) => {
                    const row = getRowData(tableMeta, columns);
                    return (
                        <>
                            <Box data-toggle="tooltip" title={value} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", width: "270px" }}>
                                <Link to={{ pathname: `/societe/${row.societeId}/missions/${row.uuid}/view` }} className="d-print-none font-sm" style={{ textDecoration: "none" }}>{value}</Link>
                            </Box>
                        </>
                    );
                },
            },
        },
        {
            name: "statut",
            label: "STATUT",
            options: {
                sort: true,
            },
        },
        {
            name: "priorite",
            label: "PRIORITE",
            options: {
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <>
                            <Box data-toggle="tooltip" title={value} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", textAlign: "left", width: "150px" }}>
                                {value ?? "-"}
                            </Box>
                        </>
                    );
                },
            },
        },
        {
            name: "createdAt",
            label: "DATE DEBUT",
            options: {
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <>
                            <Box data-toggle="tooltip" title={value} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", textAlign: "left", width: "150px" }}>
                                {value ? moment(value.date).format('DD/MM/YYYY') : "-"}
                            </Box>
                        </>
                    );
                },
            },
        },
        {
            name: "contact",
            label: "CONTACT",
            options: {
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    const row = getRowData(tableMeta, columns);
                    return (

                        <>
                            <Box data-toggle="tooltip" title={value} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", width: "100px" }}>
                                <Link to={{ pathname: `/societe/${row.societeId}/contacts/${row.contactId}/view` }}>{value}</Link>
                            </Box>
                        </>
                    );
                },
            },
        },
        {
            name: "contactId",
            label: "ID DE LA CONTACT",
            options: {
                display: false,
                sort: false,
            },
        },
        {
            name: "consultant",
            label: "CONSULTANT",
            options: {
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <>
                            <Box data-toggle="tooltip" title={value} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", textAlign: "left", width: "150px" }}>
                                {value ?? "-"}
                            </Box>
                        </>
                    );
                },
            },
        },
        {
            name: "competence_sectorielle",
            label: "COMPÉTENCES SECTORIELLES",
            options: {
                display: false,
                sort: false,
                setCellHeaderProps: () => ({ style: { whiteSpace: "nowrap" } })
            },
        },
        {
            name: "competence_metier",
            label: "COMPÉTENCES MÉTIERS",
            options: {
                display: false,
                sort: false,
                setCellHeaderProps: () => ({ style: { whiteSpace: "nowrap" } })
            },
        },

        {
            name: "CV",
            label: "CV EN PROCESSUS",
            options: {
                sort: true,
                setCellHeaderProps: () => ({ style: { whiteSpace: "nowrap" } }),
                customBodyRender: (value, tableMeta, updateValue) => {
                    const row = getRowData(tableMeta, columns);
                    return (
                        <Box data-toggle="tooltip" title={value} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", width: "100px", display: "flex", justifyContent: "center" }}>
                            <Link to={{
                                pathname: `/candidats/missions/${row.uuid}/list`,
                                search: `?quantity=${value}`,
                            }}>{value}</Link>
                        </Box>
                    );
                },
            },
        },
        {
            name: "sourcing",
            label: "SOURCÉ",
            options: {
                sort: true,
                setCellHeaderProps: () => ({ style: { whiteSpace: "nowrap" } }),
                customBodyRender: (value, tableMeta, updateValue) => {
                    const row = getRowData(tableMeta, columns);
                    return (
                        <Box
                            data-toggle="tooltip"
                            title={value}
                            onClick={() => handleSourcingClick(row)}
                            style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", width: "100px", display: "flex", justifyContent: "center", cursor: "pointer", color: "#0f9688" }}
                        >
                            {value ?? "-"}
                        </Box>
                    );
                },
            },
        },
        {
            name: "societeId",
            label: "ID DE LA SOCIETE",
            options: {
                display: false,
                sort: false,
            },
        },
        {
            name: "contactId",
            label: "ACCOUNT MANAGER",
            options: {
                display: false,
                sort: false,
                setCellHeaderProps: () => ({ style: { whiteSpace: "nowrap" } })
            },
        },
        {
            name: "Action",
            label: "ACTION",
            options: {
                customBodyRender: (data, tableMeta, updateValue) => {
                    const row = getRowData(tableMeta, columns);
                    return (
                        <Box sx={{ width: "2rem" }}>
                            <Button data-toggle="tooltip"
                                title="Modifier" onClick={() => props.editMission(row.uuid, row.societeId)} style={{ color: "#C8D148" }}>
                                <Edit />
                            </Button>
                        </Box>
                    );
                },
                display: false,
                sort: false,
            },
        },
    ];

    const [viewportHeight, setViewportHeight] = useState(window.innerHeight);
    const [sorting, setSorting] = useState(() => {
        const savedSorting = localStorage.getItem('missionsTableSorting');
        return savedSorting ? JSON.parse(savedSorting) : { name: '', order: 'asc' };
    });
    const [sourcingDetailModal, setSourcingDetailModal] = useState({
        open: false,
        data: [],
        loading: false,
        error: null,
    });

    const handleSourcingClick = (row) => {
        setSourcingDetailModal({ open: true, data: [], loading: true, error: null });

        const queryParams =
            `?missions[]=${row.uuid}` +
            `&startDate=${moment(row.createdAt?.date).format('YYYY-MM-DD')}` +
            `&endDate=${moment().format('YYYY-MM-DD')}` +
            `&type=${encodeURIComponent('Sourcing')}`;

        getPilotageClientsDetail(queryParams)
            .then(({ data }) => {
                setSourcingDetailModal((prev) => ({
                    ...prev,
                    loading: false,
                    data: Array.isArray(data) ? data : (data.items ?? []),
                }));
            })
            .catch(() => {
                setSourcingDetailModal((prev) => ({
                    ...prev,
                    loading: false,
                    error: "Erreur de chargement des données.",
                }));
            });
    };

    const sortedData = useMemo(() => {
        if (!sorting.name || !props.missionData?.data) return props.missionData?.data || [];
        const data = [...props.missionData.data];
        data.sort((a, b) => {
            let valA = a[sorting.name];
            let valB = b[sorting.name];
            if (sorting.name === 'createdAt') {
                valA = valA?.date ? new Date(valA.date).getTime() : 0;
                valB = valB?.date ? new Date(valB.date).getTime() : 0;
            }
            if (valA == null) valA = '';
            if (valB == null) valB = '';
            if (typeof valA === 'number' && typeof valB === 'number') {
                return sorting.order === 'asc' ? valA - valB : valB - valA;
            }
            return sorting.order === 'asc'
                ? String(valA).localeCompare(String(valB))
                : String(valB).localeCompare(String(valA));
        });
        return data;
    }, [props.missionData?.data, sorting]);


    useEffect(() => {
        const handleResize = () => {
            setViewportHeight(window.innerHeight);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const isSmall = useMediaQuery((theme) => theme.breakpoints.between(0, 767));
    const isMediumMode = useMediaQuery((theme) => theme.breakpoints.between(767, 1023));
    const isLargeMode = useMediaQuery((theme) => theme.breakpoints.between(1023, 2800));

    const tableBodyMaxHeight = `${isSmall ? viewportHeight - 292 : isMediumMode ? viewportHeight - 340 : isLargeMode ? viewportHeight - 310 : 200}px`;
    const tableName = props.tableName ?? "missionsColumnVisibility";
    console.log(props.tableName)
    const options = {
        rowsPerPageOptions: [50, 100, 300, 500],
        rowsPerPage: getRowsPerPage(tableName) ?? 50,
        tableBodyMaxHeight,
        serverSide: true,
        jumpToPage: true,
        textLabels: {
            body: {

                    noMatch: (props.loading || props.missionData?.isLoading) ? <CircularProgress /> : "Désolé, il n'y a aucun enregistrement dans la base de données pour le moment.",

            },
            pagination: {
                next: "Page suivante",
                previous: "Page précédente",
                rowsPerPage: "Lignes par page:",
                displayRows: "sur",
            },
        },
        selectableRows: "none",
        draggableColumns: {
            enabled: true,
        },
        filter: true,
        filterType: "dropdown",
        responsive: "standard",
        onViewColumnsChange: (columnName, action) => {
            handleOnViewColumnsChange(columnName, action, tableName);
        }
        ,
        onTableChange: (action, tableState) => {
            switch (action) {
                case "changeRowsPerPage":
                    handleChangeRowsPerPage(tableName, tableState.rowsPerPage);
                    if (props.onRowsPerPageChange) {
                        props.onRowsPerPageChange(tableState.rowsPerPage);
                    }
                    break;
                case "changePage":
                    if (props.onPageChange) {
                        props.onPageChange(tableState.page);
                    }
                    break;
                case "sort":
                    const { name, direction } = tableState.sortOrder;
                    if (name) {
                        setSorting({ name, order: direction });
                        localStorage.setItem('missionsTableSorting', JSON.stringify({ name, order: direction }));
                    }
                    break;
                default:
            }

        },
        sortOrder: { name: sorting.name, direction: sorting.order },
    };
    return (
        <>
            <MuiThemeProvider theme={missionListStyle}>
                <MUIDataTable title={"Liste des missions"} loading={props.missionData?.isLoading}
                    error={null}
                    data={sortedData} columns={columns} options={options} />
            </MuiThemeProvider>
            <ProductionDetailModal
                open={sourcingDetailModal.open}
                onClose={() => setSourcingDetailModal((prev) => ({ ...prev, open: false }))}
                metricType="Sourcing"
                data={sourcingDetailModal.data}
                loading={sourcingDetailModal.loading}
                error={sourcingDetailModal.error}
                showMetricsBar={false}
            />
        </>
    )

}

export default MissionsTable;